import React, { useState } from 'react';
import "../Signup/Signup.scss";
import bgBanner from "../../assets/images/bg-img.svg";
import LogoIcon from "../../assets/images/white_locshark_1.png";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import useApi from '../../hook/useAPI';
import { USER_MANAGEMENT } from '../../utils/const';
import { toast } from "react-toastify";

const ResetPassword = () => {
    const initialValues = {
        password: "",
        confirm_password: "",
    };
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [validationState, setValidationState] = useState({
        minLength: false,
        hasLetter: false,
        hasNumber: false,
    });
    const [requiredError, setRequiredError] = useState('');
    const [requiredConfirmError, setRequiredConfirmError] = useState('');
    const [isValid, setIsValid] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { postData, getData } = useApi();

    const validatePassword = (value) => {
        if (value) {
            setRequiredError('');
        } else {
            setRequiredError('Password is required');
        }
        const validations = {
            minLength: value.length >= 8,
            hasLetter: /[A-Za-z]/.test(value),
            hasNumber: /\d/.test(value),
        };
        setValidationState(validations);
        setPassword(value);
    };
    const checkPassword = (e) => {
        setConfirmPassword(e.target.value);

        if (password !== e.target.value) {
            setConfirmPasswordError(true);
            setIsValid(false);
        } else {
            setConfirmPasswordError(false);
            setIsValid(true);
        }
    }

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .test(
                "min-length",
                "Password must be at least 8 characters long",
                (value) => value && value.length >= 8
            )
            .test(
                "contains-letter",
                "Password must contain at least one letter",
                (value) => value && /[A-Za-z]/.test(value)
            )
            .test(
                "contains-number",
                "Password must contain at least one number",
                (value) => value && /\d/.test(value)
            )
            .required("Password is required"),
        confirm_password: Yup.string()
            .oneOf([Yup.ref("password")], "Passwords don't match")
            .required("Confirm password is required"),
    });

    const handleUpdatePassword = async () => {
        if (!password) {
            setRequiredError('Password is required');
            return;
        } else {
            setRequiredError('');
        }
        let checkValidation = Object.values(validationState).every(value => value === true);

        if (!checkValidation || !isValid) {
            return;
        }

        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get("token");

        if (!token) {
            toast.error('Validation Token Missing!');
            return;
        }
        
        let payload = {
            password: password,
            token: token
        };
        const response = await postData(USER_MANAGEMENT.RESET_PASSWORD, payload);

        if (response && response.status && response.status === 200) {
            toast.success(response?.message);
            setTimeout(() => {
                navigate('/');
            }, 2000);
        } else {
            toast.error(response?.message || 'Something went wrong!');
        }
    };

    const handleBlurEvent = (e) => {
        if (e.target.value.trim() == '') {
            setRequiredError('Password is required');
        } else {
            setRequiredError('');
        }
    }
    const handleConfirmBlurEvent = (e) => {
        if (e.target.value.trim() == '') {
            setConfirmPasswordError('Password is required');
        } else {
            setConfirmPasswordError('');
        }
    }

    return (
        <div className="login-section signup-page reset-password-page">
            <div className="container">
                <div className="row m-0">
                    <div className="col-md-4 p-0">
                        <div className="sign-bg-banner">
                            <img src={bgBanner} className="img-fluid" alt="signup-background" />
                            <div className="over-sml-img">
                                <img src={LogoIcon} className="img-fluid" alt="signup-logo" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 d-flex align-items-center justify-content-center px-0 px-sm-0 px-md-4">
                        <div className="create-ac-main-box">
                            <center>
                                <h4 className="mt-4">Update Password</h4>
                            </center>
                            <div className="create-account-box">
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                >
                                    {({
                                        values,
                                        touched,
                                        errors,
                                        handleBlur,
                                        handleChange,
                                        handleSubmit,
                                    }) => (
                                        <form onSubmit={handleSubmit} noValidate>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form_field_wrapper">
                                                        <label>New Password</label>
                                                        <input
                                                            value={password}
                                                            type="password"
                                                            name="password"
                                                            className="form-control"
                                                            placeholder="Enter New Password"
                                                            onChange={(e) => validatePassword(e.target.value)}
                                                            onBlur={(e) => handleBlurEvent(e)}
                                                        />
                                                        <small style={{color: "red"}}>{requiredError}</small>

                                                        {/* {errors.password && touched.password && (
                                                            <div className="error-message">
                                                                {errors.password}
                                                            </div>
                                                        )} */}

                                                        <div className="validation-list mt-3 p-3" style={{border: "1px solid #ccc", "borderRadius": "10px"}}>
                                                            <div className={validationState.minLength ? "valid" : "invalid"}>
                                                                { 
                                                                    validationState.minLength ? 
                                                                        <span style={{color: "#13BF00", fontWeight: "900", fontSize: "16px"}}><i className='bi bi-check2-circle fs-4'></i> At least 8 characters</span> : <span style={{fontSize: "16px"}}><i className='bi bi-check2-circle text-muted fs-4 align-middle'></i> At least 8 characters</span>
                                                                }
                                                            </div>
                                                            <div className={validationState.hasLetter ? "valid" : "invalid"}>
                                                            { 
                                                                    validationState.hasLetter ? 
                                                                        <span style={{color: "#13BF00", fontWeight: "900", fontSize: "16px"}}><i className='bi bi-check2-circle fs-4'></i> At least one letter</span> : <span style={{fontSize: "16px"}}><i className='bi bi-check2-circle text-muted fs-4 align-middle'></i> At least one letter</span>
                                                            }
                                                            </div>
                                                            <div className={validationState.hasNumber ? "valid" : "invalid"}>
                                                            { 
                                                                    validationState.hasNumber ? 
                                                                        <span style={{color: "#13BF00", fontWeight: "900", fontSize: "16px"}}><i className='bi bi-check2-circle fs-4'></i> At least one number</span> : <span style={{fontSize: "16px"}}><i className='bi bi-check2-circle text-muted fs-4 align-middle'></i> At least one number</span>
                                                            }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form_field_wrapper">
                                                        <label>Confirm Password</label>
                                                        <input
                                                            value={confirm_password}
                                                            type="password"
                                                            name="confirm_password"
                                                            className="form-control"
                                                            placeholder="Confirm Password"
                                                            onChange={(e) => checkPassword(e)}
                                                            onBlur={(e) => handleConfirmBlurEvent(e)}
                                                        />
                                                        {
                                                            confirmPasswordError && <span className='text-danger'>Password doesn't match</span>
                                                        }

                                                        {/* {errors.confirm_password &&
                                                            touched.confirm_password && (
                                                                <div className="error-message">
                                                                    {errors.confirm_password}
                                                                </div>
                                                            )} */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="create-account-btn">
                                                <button type="submit" onClick={handleUpdatePassword}>Save Changes</button>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
